var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"badge-block"},[_c('div',{staticClass:"badge-block_bg"}),_vm._v(" "),_c('default-box',{staticClass:"badge-block__content",class:_vm.block_classes},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }